var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('vue-lottie-player',{attrs:{"autoplay":"","loop":"","mode":"normal","animationData":require('pinnacle-lib/assets/lottie/world-loader.json'),"width":"48px","height":"48px","name":"loader"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }